<template>
    <div class="about flex flex-wrap">
        <div class="img"><img :src="column[3]['picurl']" alt=""></div>
        <div class="text">
            <div class="title wow bounceInRight">{{column[3]['title']}}</div>
            <div class="container wow bounceInRight">
                <div class="content" v-html="this.column[3]['content']"></div>
                <div class="data clearfix">
                    <div class="item">
                        <div class="num"><span id="num1">47000</span><span class="small">M²</span></div>
                        <div class="txt">Plant Area</div>
                    </div>
                    <div class="item">
                        <div class="num"><span id="num2">100</span>⁺</div>
                        <div class="txt">Number of Customers Served</div>
                    </div>
                </div>
                <div class="link flex flex-space-between flex-align-center" @click="goto">
                    <div class="txt">
                        <div class="t1">more about</div>
                        <div class="t2">FUNJOY</div>
                    </div>
                    <i class="fa fa-arrow-right"></i>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import CountUp from "./countup.js";
import Scrollbar from 'smooth-scrollbar';

import {get_column} from "../../../util/lang";


export default {
  data(){
    return {
      column:{},
    }
  },
  mounted(){
      let element=document.getElementById('num1');
      let actualTop = element.offsetTop;
      let current = element.offsetParent;
      while (current !== null){
        actualTop += current.offsetTop;
        current = current.offsetParent;
      }
          let demoFi1 = new CountUp("num1", 0, 47000, 0, 2);
          let demoFi2 = new CountUp("num2", 0, 100, 0, 2);
      let numok=false;
      this.$nextTick(()=>{
        let scrollbar=Scrollbar.get(document.getElementById('scroller-wrapper'))
        scrollbar.addListener((status) => {
          if(!numok){
            if(actualTop<status.offset.y+document.body.clientHeight){
              demoFi1.start();
              demoFi2.start();
              numok=true;
            }
          }
        });
      })
  },
  methods: {
   fetchDate(){
    const url = get_column();
     this.$$axios.get(url).then(res => {
     this.column = res.data
       // console.log(this.banner)
       // this.banner.map((item)=>{
       //   item.EN=item.EN.replace(/\n/g, "<br>")
       // })
     }).then(()=>{

     })
    },
    goto(){
      this.$router.push({
        name: 'about',
        params: {
          tid: 1
        }
      })
    }
  },
  created() {
    this.fetchDate()
  }
}
</script>

<style scoped>
.about{
    padding: 100px 0;
}
.about .img{
    width: 50%;
    text-align: center;
}
.about .img img{
    mix-blend-mode: darken;
    max-width: 100%;
}
.about .text{
    width: 50%;
    padding: 3%;
    overflow: hidden;
}
.about .text .title{
    font-size: 40px;
    color: #004b94;
    border-bottom: 1px solid #b7b5c0;
    padding: 15px 0;
}
.about .text .container{
    width: 620px;
    max-width: 100%;
    padding: 30px 0;
}
.about .text .container .content{
    font-size: 14px;
    color: #737373;
    line-height: 30px;
}
.about .text .container .content p{
    margin: 0;
}
.about .text .container .data{
    margin-top: 50px;
}
.about .text .container .data .item{
    float: left;
    /* margin-right: 11%; */
    width: 33.33%;
    color: #004b94;
}
.about .text .container .data .item .num{
    font-size: 30px;
    line-height: 50px;
    font-family: 'CANARO BOLD';
}
.about .text .container .data .item .num .small{
    font-size: 16px;
    vertical-align: bottom;
}
.about .text .container .data .item .txt{
    font-size: 14px;
}
.about .text .container .link{
    font-family: 'CANARO BOLD';
    border: 1px solid #004b94;
    color: #004b94;
    padding: 5px 10px;
    text-transform: uppercase;
    width: 250px;
    max-width: 100%;
    margin-top: 50px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
    transition: .3s;
    z-index: 3;
}
.about .text .container .link .txt .t1{
    font-size: 20px;
    line-height: 1em;
}
.about .text .container .link .txt .t2{
    font-size: 16px;
    line-height: 1em;
}
.about .text .container .link i{
    transition: .3s;
}
.about .text .container .link::before{
    content: "";
    position: absolute;
    top: 0;
    left: -100%;
    width: 100%;
    height: 100%;
    background-color: #004b94;
    transition: .3s;
    border-radius: 0 50px 50px 0;
    border-right: 50px solid #004b94;
    margin-left: -50px;
    z-index: -1;
}
.about .text .container .link:hover::before{
    left: 0;
    margin-left: 0;
}
.about .text .container .link:hover{
    color: #fff;
}
@media (max-width: 1500px){
  .about .text .title {
    font-size: 28px;
  }
  .about .text .container .data .item .num {
    font-size: 24px;
  }
}
@media (max-width: 768px){
  .about{
    padding: 50px 0 20px;
  }
  .about .img,.about .text{
    width: 100%;
  }
  .about .text .title{
    font-size: 24px;
  }
  .about .text .container .data .item {
    width: fit-content;
  }
  .about .text .container .data .item:nth-child(1) {
    margin-right: 20px;
  }
  .about .text .container .data .item .num{
    font-size: 20px;
    line-height: 30px;
  }
  .about .text .container .data .item .num .small{
    font-size: 12px;
  }
}
</style>


